import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace SettleApi {
    /**
    *  获取结算方列表
    */
    export var GetSettleList = (body: any): Promise<any> => {
        return Get(`/csp/Settle/GetList?${qs.stringify(body)}`, {});
    };
    /**
    * 添加结算方
    */
    export var AddSettleUser = (body: any): Promise<any> => {
        return Post(`/csp/Settle`, body);
    };
    /**
    * 获取结算方详细/csp/Settle/{id}
    */
    export var GetSettleUserDetail = (id: any): Promise<any> => {
        return Get(`/csp/Settle/${id}`, {});
    };
    /**
     * 修改结算方
     */
    export var UpdateSettleUser = (id: any, body: any): Promise<any> => {
        return Put(`/csp/Settle/${id}`, body);
    };
}